import customAxios from "./axiosConfig";
import store from '../../store'

const CompanyService = {
  list: function () {
    return customAxios.get(window.Urls["company_profile_list"]());
  },
  create: function(data) {
    var api_url = '/api/v3/company-profiles/';

    var headers = {
      headers: {
          'Content-Type': 'multipart/form-data'
        }
    };
    const getFormData = object => Object.keys(object).reduce((formData, key) => {
      if (Array.isArray(object[key])) {
        formData.append(key, JSON.stringify(object[key]))
      } else {
        formData.append(key, object[key])
      }
      return formData
    }, new FormData())
    return customAxios.post(api_url, getFormData(data), headers);
  },
  getBusinessEntities: function () {
    return customAxios.get(window.Urls["company_profile_business_entities_choices"]());
  },
  getSectors: function () {
    return customAxios.get(window.Urls["company_profile_sector_choices"]());
  },
  getStates: function(params) {
    var api_url = window.Urls['company-profile-state-choices']();
    return customAxios.get(api_url, {params: params});
  },
  getCountries: function () {
    return customAxios.get(window.Urls["company_profile_country_choices"]());
  },
  getAllChoices: function() {
    return customAxios.get(window.Urls["company_profile_all_choices"]());
  },
  getCurrent: function () {
    const api_url = window.Urls["company_profile_detail"](store.getters['main/getCompanyId'])
    return customAxios.get(api_url, { params: { extended: true } });
  },
  getCustomerCompany: function (pk) {
    const api_url = window.Urls["company_profile_detail"](pk)
    return customAxios.get(api_url, { params: { extended: true } })
  },
  update: function (data) {
    const api_url = window.Urls['company_profile_detail'](data.id)
    const headers = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    const getFormData = object => Object.keys(object).reduce((formData, key) => {
      if (Array.isArray(object[key])) {
        formData.append(key, JSON.stringify(object[key]))
      } else {
        if (object[key] !== null) {
          formData.append(key, object[key])
        }
      }
      return formData
    }, new FormData())
    return customAxios.put(api_url, getFormData(data), headers)

  },
  updateLogo(pk, data) {
    console.log('data', data)
    var url = window.Urls['company_profile_detail'](pk);
    var headers = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    };
    const getFormData = object => Object.keys(object).reduce((formData, key) => {
        if(Array.isArray(object[key])){
            formData.append(key, JSON.stringify(object[key]));
        }else{
            formData.append(key, object[key]);
        }
        return formData;
    }, new FormData());
    return customAxios.put(url, getFormData(data), headers);
  },
  uploadLogo (pk, payload) {
    const formData = new FormData()
    formData.append('logo', payload.file)
    if (payload.logo_id) {
      formData.append('default_logo', payload.logo_id)
    }
    var url = window.Urls['company_profile_detail'](pk)
    var headers = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    return customAxios.patch(url, formData, headers);
  },
  deleteLogo (pk) {
    var url = window.Urls['company_profile_delete_logo'](pk)
    return customAxios.delete(url);
  },
  companyPickerOptions: function(){
    return customAxios.get(window.Urls["company_profile_company_picker_options"]());
  },
  getAccessRights: function () {
    return customAxios.get(window.Urls["company_profile_access_rights"](store.getters['main/getCompanyId']));
  },
  financiallyActiveYears: function(company_id = null) {
    let companyId = (company_id) ? company_id : store.getters['main/getCompanyId']
    var api_url = window.Urls['companyProfileFinanciallyActiveYears'](companyId);
    return customAxios.get(api_url);
  },
  retrieveAccountant (accountant_id) {
    const api_url = '/api/v2/accountant-profiles/' + accountant_id + '/'
    return customAxios.get(api_url);
  },
  retrieveAccountantConnections (company_id) {
    const api_url = '/api/v2/accountant-connections/'
    return customAxios.get(api_url, { params: { company_id: company_id } });
  },
  downloadData(company_id,data){
    const api_url = window.Urls["company_profile_download_data"](company_id);
    return customAxios.post(api_url, data);
  },
  searchKvk(params) {
    var api_url = window.Urls['company-profile-search-kvk']();
    return customAxios.get(api_url, {params: params});
  },
  importKvk(data) {
    var api_url = window.Urls['company-profile-kvk-import'](store.getters['main/getCompanyId']);
    return customAxios.post(api_url, data);
  },
  getKvkPageByUrl(params) {
    var api_url = window.Urls['company-profile-get-kvk-page-by-link']();
    return customAxios.get(api_url, {params: params});
  },
  kvkDataToCompany(kvkData) {
    let companyData = {}
    
    if (kvkData.handelsnaam) {
      companyData.name = kvkData.handelsnaam
    } else if (kvkData.naam) {
      companyData.name = kvkData.naam
    } else {
      companyData.name = ''
    }

    companyData.name = kvkData.naam;
    companyData.city = kvkData.plaats;
    companyData.address = kvkData.straatnaam;
    companyData.kvk = kvkData.kvkNummer;
    companyData.country = "NL";

    return CompanyService.getAllChoices().then((choices) => {
      let kvk_legal_form_options = choices.data.kvk_legal_form_options;

      let params = {url: kvkData.links[0].href};
      return CompanyService.getKvkPageByUrl(params).then((response) => {
          if ('hoofdvestiging' in response.data['_embedded'] && 'adressen' in response.data['_embedded']['hoofdvestiging']) {
              let address = response.data['_embedded']['hoofdvestiging']['adressen'][0];

              let street_address = '';
              if (address['straatnaam'])
                  street_address = address['straatnaam'];
              if (address['huisnummer'])
                  street_address = street_address + ' ' + address['huisnummer'];
              if (address['huisnummertoevoeging'])
                  street_address = street_address + '-' + address['huisnummertoevoeging'];

              companyData.address = street_address;
              companyData.postal_code = address['postcode'];
              companyData.city = address['plaats'];
          }

          let business_activities = response.data['sbiActiviteiten'][0];
          companyData.description = business_activities['sbiOmschrijving'];
          companyData.sbi_description = business_activities['sbiOmschrijving'];
          companyData.sbi_code = business_activities['sbiCode'];
          
          if (response.data['_embedded']['hoofdvestiging']['websites'])
              companyData.website = response.data['_embedded']['hoofdvestiging']['websites'][0];
          
          if (kvk_legal_form_options) {
              if (response.data['_embedded']['eigenaar']['rechtsvorm'] in kvk_legal_form_options)
                  companyData.legal_form = kvk_legal_form_options[response.data['_embedded']['eigenaar']['rechtsvorm']];
          }
          return companyData;
      });
    });
  },
  destroy: function(id) {
    const api_url = window.Urls['company_profile_detail'](id);
    return customAxios.delete(api_url);
  },
  copyToBrand: function(){
    var data = {};
    var api_url = window.Urls['company_profile_save_as_brand'](store.getters['main/getCompanyId']);
    return customAxios.post(api_url, data);
  },
};

export default CompanyService;